import "@/components/home/site-footer.css";
import "@/components/ui/atoms/categories/data-display.css";
import { DisputeWellLogo } from "@/components/ui/molecules/OrgLogo";
import { routes } from "@/lib/routing/routes";
import Link from "next/link";
import { memo } from "react";

export const SiteFooter = memo(function SiteFooter() {
  return (
    <footer
      className="dw-home-site-footer" data-component="SiteFooter" data-location="src/components/home/site-footer.tsx">
      <div className="dw-home-site-footer__row">
        <Link href="/">
          <DisputeWellLogo width={1147} height={221} className="dw-home-site-footer__logo" />
        </Link>
        <nav className="dw-home-site-footer__links" aria-label="Footer">
          <Link href="/features" className="dw-text-caption dw-tabular-nums" data-tone="muted">
            Features
          </Link>
          <Link href="/blog" className="dw-text-caption dw-tabular-nums" data-tone="muted">
            Blog
          </Link>
          <Link href="/terms" className="dw-text-caption dw-tabular-nums" data-tone="muted">
            Terms
          </Link>
          <Link href={routes.crm.login} className="dw-text-caption dw-tabular-nums" data-tone="muted">
            Log in
          </Link>
          <Link
            href="https://x.com/DisputeWelll"
            target="_blank"
            rel="noopener noreferrer"
            className="dw-text-caption dw-tabular-nums" data-tone="muted"
          >
            X
          </Link>
        </nav>
      </div>
      <p className="dw-home-site-footer__legal dw-text-caption" data-tone="muted">
        &copy; {new Date().getFullYear()} DisputeWell. All rights reserved.
        DisputeWell is software for credit repair businesses; it is not a credit
        repair organization and does not provide credit repair services to
        consumers. No specific credit score outcomes are guaranteed; results
        vary.
      </p>
    </footer>
  );
});
